import firebase from 'firebase/app';
export async function getConfigs() {
    var db = firebase.firestore();
    var configs = await db.collection('configs').get();
    var configsObj = {};
    configs.docs.map((doc) => (configsObj[doc.id] = doc.data()));
    return configsObj;
}
